const DEFAULT_FADEIN_CONFIG = {
  delay: 0,
  duration: 2000,
  callback: null,
  iterationCount: 1,
  easing: 'linear',
};
const DEFAULT_FADEOUT_CONFIG = {
  delay: 0,
  duration: 2000,
  callback: null,
  iterationCount: 1,
  easing: 'linear',
};
const DEFAULT_BOUNCE_CONFIG = {
  delay: 0,
  duration: 2000,
  callback: null,
  iterationCount: 1,
  easing: 'bounce',
  dropHeight: -20,
};
const DEFAULT_PULSE_CONFIG = {
  delay: 0,
  duration: 2000,
  callback: null,
  iterationCount: 1,
  easing: 'linear',
  scale: 1.2,
};
const DEFAULT_SLIDEUPDOWN_CONFIG = {
  delay: 0,
  duration: 2000,
  callback: null,
  iterationCount: 1,
  easing: 'linear',
  maxHeight: -20,
};
export {
  DEFAULT_FADEIN_CONFIG,
  DEFAULT_BOUNCE_CONFIG,
  DEFAULT_FADEOUT_CONFIG,
  DEFAULT_PULSE_CONFIG,
  DEFAULT_SLIDEUPDOWN_CONFIG,
};
